<template>
  <v-card flat class=" mx-2">
    <v-card-title class="pb-0">{{$t('media.file.filters')}}</v-card-title>
    <v-card-text class="pt-0 mt-0">
      <v-row>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col cols="12" sm="6" md="4"  >
              <date-input
                v-if="filters[0].field == 'dateFrom'"
                v-model="filters[0].value"
                :label="$t('media.file.from')"
                prepend-icon="event"
                color="secondary"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="4"  >
              <date-input
                v-model="filters[1].value"
                :label="$t('media.file.until')"
                prepend-icon="event"
                color="secondary"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="filters[2].value"
                :label="$t('media.file.filename')"
                prepend-icon="article"
                color="secondary"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="filters[4].value"
                :label="$t('media.file.type')"
                :items="selectType"
                prepend-icon="extension"
                color="secondary"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6"  md="2">
              <v-text-field
                v-model="filters[5].value"
                :label="$t('media.file.sizeGt')"
                prepend-icon="album"
                color="secondary"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="filters[6].value"
                :label="$t('media.file.sizeLt')"
                prepend-icon="album"
                color="secondary"
                hide-details
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn small text color="secondary" @click="cleanFilters()">{{
            "Limpiar filtros"
          }}</v-btn>

          <v-btn small color="secondary" @click="setFilters()">{{
            "Aplicar filtros"
          }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import { DateInput } from '@dracul/dayjs-frontend';


export default {
  name: "FileFilters",
  components: { DateInput },
  props: {
    value: Array
  },
  computed: {
    filters: {
      get() {
        return this.value},
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      selectType: [
        { text: this.$t("text"), value: "text" },
        { text: this.$t("image"), value: "image" },
        { text: this.$t("application"), value: "application" },
        { text: this.$t("audio"), value: "audio" }
      ]
    }
  },
  methods: {
    setFilters() {
      this.$emit("updateFilters", this.filters);
    },
    cleanFilters() {
      this.$emit("clearFilter", this.filters);
    },
  },
};
</script>
